import { get, handleQueryStringForApi } from '@mindtickle/api-helpers';

import { BannerData } from '../types';

const API = handleQueryStringForApi({
  maintenance: () => ({
    url: `/maintenance-banner`,
  }),
});

export const getMaintenanceBanner = async ({
  cname,
}: {
  cname: string;
}): Promise<{
  adminRoutes?: Record<string, BannerData>;
  learnerRoutes?: Record<string, BannerData>;
}> => {
  try {
    const result = await get(
      API.maintenance({
        query: {
          cname,
        },
      })
    );
    return result;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
    return {};
  }
};
